var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat"},[_c('div',{ref:"box",staticClass:"chat-box"},_vm._l((_vm.messages),function(message,i){return _c('p',{key:i,class:{
        message: message.event === 'message',
        userEvent: message.event === 'join' || message.event === 'leave',
        me: message.participantId === _vm.$magpie.socket.participantId
      },style:({
        ...(message.message && {
          background: _vm.$magpie.socket.getParticipantColor(
            message.participantId
          )
        }),
        ...(!message.message && {
          color: _vm.$magpie.socket.getParticipantColor(message.participantId)
        })
      }),domProps:{"textContent":_vm._s(
        message.message ||
        (message.participantId === _vm.$magpie.socket.participantId
          ? message.event === 'join'
            ? _vm.$t('interactive.Chat.statusYouJoined')
            : message.event === 'leave'
            ? _vm.$t('interactive.Chat.statusYouLeft')
            : ''
          : message.event === 'join'
          ? _vm.$t('interactive.Chat.statusParticipantJoined', {
              user: _vm.$magpie.socket.getParticipantName(message.participantId)
            })
          : message.event === 'leave'
          ? _vm.$t('interactive.Chat.statusParticipantLeft', {
              user: _vm.$magpie.socket.getParticipantName(message.participantId)
            })
          : '')
      )}})}),0),_c('div',{staticClass:"chat-input"},[_c('textarea',{ref:"text",attrs:{"cols":"50","placeholder":_vm.$t('interactive.Chat.messageLabel')},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;$event.preventDefault();return _vm.send.apply(null, arguments)}}}),_c('button',{on:{"click":function($event){$event.stopPropagation();return _vm.send()}}},[_vm._v(_vm._s(_vm.$t('general.send')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }